export default function () {
  const widgetName = 'masonryCards';
  const widgetOpts = masonryCardsOpts;

  const breakpoint = 900;
  const isDesktopScreen = $(window).width() >= breakpoint;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    cardWidgetLoaded: function (data) {
      const widgetItems = data.items;

      if (widgetItems.length == 0) {
        $('.tier-2-container .inner-container').addClass(`${widgetName}-no-data`);
        $(`#${widgetName}`).remove();
        $(`.tier-2-container`).remove();
      } else {
        $(`#${widgetName}`).addClass(`grid-${widgetItems.length}`);
        createGallery(widgetItems);
      }
    },
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    maxItemsVisible: 6,
    itemsPerPanel: 6,
    showDescription: true,
    moreButton: {
      visible: true,
      text: 'More',
    },
  });

  // ****************************************************************
  // Function Helpers
  function createGallery(data) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      let $card = $(this);

      $card.removeAttr('target');
      $card.find('.moreButton').addClass('button').removeClass('moreButton').removeAttr('target');

      $card
        .find('.card-widget-description, .buttonwrap')
        .wrapAll('<div class="overlay-content"></div>');
      if (!data[x].URL && !data[x].Description) {
        $card.addClass('card-empty').removeAttr('href');
        $card.find('.buttonwrap').remove();
        $card.find('.card-widget-description').remove();
      } else if (!data[x].URL && data[x].Description) {
        $card.addClass('no-btn').removeAttr('href');
        $card.find('.buttonwrap').remove();
      } else if (data[x].URL && !data[x].Description) {
        $card.addClass('no-description');
        $card.find('.card-widget-description').remove();
      } else {
        return;
      }
    });
  }
}
